import React, {useState, useEffect} from 'react'
import './heroSection.css'

import { AiFillGithub, AiFillLinkedin, AiOutlineMail} from 'react-icons/ai';
import { FaSquareXTwitter } from "react-icons/fa6";

import  profile1 from '../../assets/images/behzadPic02.jpeg';

import blogCta from "../../components/blogCta/blogCta";
import { Link } from "react-router-dom";

const HeroSection = () => {

  const [mobileScreen, setMobileScreen] = useState(window.innerWidth <= 650); // Set initial state based on window size

  useEffect(() => {
    // Function to check and update the screen size
    const handleResize = () => {
      setMobileScreen(window.innerWidth <= 650);
    };

    // Add event listener for resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section id='home' className='heroSection'>
      <div className='heroSectionContainer'>

          <div className='heroSectionContainerLeft'>
              <h1>Bahzad Tabari</h1>
             
                <p>
                I am a <span className='aBoldText'>Computational Mechanics</span> Specialist passionate about solving complex challenges at the intersection of <span className='aBoldText'>mechanical engineering</span> and <span className='aBoldText'>artificial intelligence</span>. I develop intelligent, ML and data-driven software that enhances engineering workflows, automates decisions, and improves digital manufacturing processes.
              </p>
            
              <h3 >Based in Munich, Germany</h3>

              <a href='#contact' className='buttonToContactMe'>Contact Me</a>
              
              
              
          </div>
          <div className='heroSectionContainerRigt'>
              <div className='profilePictureContainer'>
                 {!mobileScreen && <img className='profilePicture' src={profile1} alt='my profile picture' /> }
              </div>
              <div className='heroSectionIconSocialMedia'>
                <a href="https://github.com/behzadtabari" target="_blank" rel="noopener noreferrer" aria-label="Github">
                  <AiFillGithub className="socialIcon" />
                </a>
                <a href="https://www.linkedin.com/in/behzadtabari/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <AiFillLinkedin className="socialIcon" />
                </a>
                <a href="mailto:behzadtabari.bt@gmail.com" aria-label="Email">
                  <AiOutlineMail className="socialIcon" />
                </a>
                <a href="https://x.com/behzadtabari_bt" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaSquareXTwitter className="socialIcon" />
                </a>
              </div>
          </div>
      </div>
    </section>
  )
}

export default HeroSection
